var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import * as React from "react";

function SvgShInformationCircleOutline(props) {
  return React.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 17.042 17.042"
    }, props),
    React.createElement("path", { d: "M7.678 5.088a.844.844 0 11.84.819.82.82 0 01-.84-.819zm.057 1.462H9.3v5.9H7.735z" }),
    React.createElement("path", { d: "M8.525 1.147a7.371 7.371 0 11-5.219 2.159 7.325 7.325 0 015.219-2.159m0-1.147a8.521 8.521 0 108.517 8.525A8.52 8.52 0 008.525 0z" })
  );
}

export default SvgShInformationCircleOutline;